import axios from 'axios'
import store from '../store/index'
import {
  getToken
} from "../assets/js/auth";
import {
  servertoken
} from "../assets/js/utils.js";
import {
  msgtip
} from "../assets/js/msgtip" //消息提示
import {
  baseURL
} from "../assets/js/baseURL"
import router from '../router';
// import websocket from "../../src/common/js/websocket";

/**
 * 默认配置
 * isauth 是否认证
 * passerr 错误直接提示,不需要返回
 */
const defaultOpt = {
  passerr: false,
  isauth: true,
}


/**
 * 创建axios实例
 */
export const service = axios.create({
  // baseURL:'http://192.169.1.12',
  baseURL: baseURL,
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 6000 // 超时请求
})

/**
 * 请求拦截器
 * 请求前
 */
service.interceptors.request.use(
  config => {
    if (config.isauth) {
      config.headers['Authori-zation'] = 'Bearer ' + getToken()
    }
    config.headers['version'] = 'v1';
    // const serverToken = servertoken()
    // config.headers['ServerToken'] = 'JZH ' + serverToken.app_token
    // if (config.data) {
    //   config.data.app_time = serverToken.app_time;
    // } else if (config.params) {
    //   config.params.app_time = serverToken.app_time;
    // }
    return config
  },
  error => {
    // do something with request error
    // console.log(error) // for debug
    return Promise.reject(error)
  }
)

/**
 * 响应拦截器
 */
service.interceptors.response.use(
  response =>
    response.status === 200 && response.data.status === 200 ? response.data : errorHandle(response),
  error => {
    // console.log('88888err' + error)
    const {
      response
    } = error
    if (response) {
      errorHandleServer(response.status, response.data.message)
    } else {
      // 跨域获取不到状态码或者其他情况
      //情况一、请求超时
      if (error == 'Error: timeout of 6000ms exceeded') {
        // msgtip('网络出现问题,请稍后重试')
        // store.commit("SETWORKSTATE", false);

      }
    }
    return Promise.reject({
      server: true
    })
  }
)
/**
 * 响应拦截器
 * @param {*} res
 */
const errorHandle = (res) => {
  var status = res.data.status
  var msg = res.data.msg
  var data = res.data
  // 请登录、登录过期、登录状态有误等
  if ([100000, 100001, 100002, 400006, 400001, 410000].indexOf(status) !== -1) {
    // return Promise.reject({
    //   server: true
    // })
    router.replace({
      path: '/'
      //登录成功后跳入浏览的当前页面
      // query: {redirect: router.currentRoute.fullPath}
    })
    msgtip('请求异常,请重新登录')
    loginout()
  } else {
    //接口错误
    return Promise.reject({
      msg: msg,
      res,
      data,
      server: false
    })
  }
}

/**
 * 服务端请求失败后的错误统一处理
 * @param {*} status
 * @param {*} msg
 */
const errorHandleServer = (status, msg) => {
  switch (status) {
    case 400:
      msgtip('错误请求')
      break
    case 401:
      msgtip('未授权,请重新登录')
      break
    case 403:
      msgtip('拒绝访问')
      break
    case 404:
      msgtip('请求错误,未找到该资源')
      break
    case 405:
      msgtip('请求方式不允许')
      break
    case 408:
      msgtip('请求超时')
      break
    case 500:
      msgtip('服务器出错')
      break
    case 501:
      msgtip('网络未实现')
      break
    case 502:
      msgtip('网络异常')
      break
    case 503:
      msgtip('服务不可用')
      break
    case 504:
      msgtip('网络超时')
      break
    case 505:
      msgtip('http版本不支持该请求')
      break
    default:
      msgtip(msg)
  }
  return Promise.reject({
    server: true
  })
}


/**
 * 请求返回基础封装
 * @param {*} options
 */
function baseRequest(options) {
  const headers = options.headers || {}
  options.headers = headers
  return new Promise((resolve, reject) => {
    if (options.isauth) {
      // 登录过期提示去登录
      if (!checkLogin()) {
        loginout(); //重新登录
      }
    }
    service(options).then(response => {
      // store.commit("SETWORKSTATE", true); //控制断网遮罩
      if (options.successTips) {
        // TipNotification(response.msg, '成功', 'success')
        resolve(response)
      } else {
        resolve(response)
      }
    }).catch(error => {
      // 服务出现的问题 不需要返回到页面
      if (error.server) { } else {
        if (options.passerr) {
          // 需要抛错到页面
          reject(error.data)
        } else {
          // 不需要
          msgtip(error.msg);
        }
      }
    })
  })
}

/**
 * 跳转登录
 */
function toLogin() {
  // Message.error('缺少token参数,请重新登录');
  // MessageBox.confirm('您已注销，您可以取消停留在该页上，或重新登录', '确认注销', {
  //   confirmButtonText: '重新登录',
  //   cancelButtonText: '取消',
  //   type: 'warning'
  // }).then(() => {
  //   store.dispatch('user/resetToken').then(() => {
  //     location.reload()
  //   })
  // })
}
/**
 * 核对登录
 */
function checkLogin() {
  let token = getToken();
  if (token) {
    return true
  } else {
    return false
  }
}
/**
 * 登出
 */


function loginout() {
  store.commit("LOGINOUT");
  // websocket.websocket.closeit();
}


/**
 * http 请求基础类
 */
const request = ['post', 'put', 'patch'].reduce((request, method) => {
  /**
   *
   * @param {*} url 接口地址
   * @param {*} data object post 参数
   * @param {*} options object axios 配置项
   */
  request[method] = (url, data = {}, options = {}) => {
    return baseRequest(
      Object.assign({
        url,
        data,
        method
      }, defaultOpt, options)
    )
  }
  return request
}, {});

['get', 'delete', 'head'].forEach(method => {
  /**
   *
   * @param {*} url 接口地址
   * @param {*} params object get 参数
   * @param {*} options object axios 配置项
   */
  request[method] = (url, params = {}, options = {}) => {
    return baseRequest(
      Object.assign({
        url,
        params,
        method
      }, defaultOpt, options)
    )
  }
})

export default request



// WEBPACK FOOTER //
// ./src/network/request.js